import { ILocality } from './locality.model';
import { ICountry } from './country.model';

export interface IProvince {
  id?: number;
  name?: string;
  localities?: ILocality[] | null;
  country?: ICountry | null;
}

export const defaultValue: Readonly<IProvince> = {};
